import styled from "styled-components";
import { hex2rgba } from "../../../../utils/styles";
import Box from "../../../../components/Box";

export const StyledSidebar = styled.aside`
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 320px;
    height: 100vh;
    background-color: ${({ theme }) => hex2rgba(theme.colors.lightBlue, 0.1)};
    z-index: 99;
`;

export const StyledSidebarTop = styled.div`
    padding: 40px;
`;

export const StyledAvatarBox = styled(Box)`
    margin-bottom: 35px;
`;